import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Play } from "lucide-react";
import { useI18n } from "../lib/LanguageContext";
import { localizeContent } from "../lib/translations";

export default function EducationPage() {
  const { t, lang } = useI18n();
  const [data, setData] = useState({ articles: [], videos: [] });
  useEffect(() => { api.get("/education").then(r => setData(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="education-page">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-teal mb-2">{t("education.title")}</div>
        <h1 className="font-display text-4xl md:text-5xl font-medium mb-10">{t("education.headline")}</h1>
      <section className="mb-14">
        <h2 className="font-display text-2xl font-medium mb-6">{t("education.articles")}</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.articles.map(a => (
            <Card key={a.id} className="overflow-hidden rounded-2xl border-teal/10 group" data-testid={`article-${a.id}`}>
              <div className="aspect-video overflow-hidden bg-teal-soft"><img src={a.cover} className="w-full h-full object-cover group-hover:scale-105 transition-transform" alt=""/></div>
              <div className="p-5">
                <h3 className="font-display text-lg leading-snug mb-2">{localizeContent(a.title, lang)}</h3>
                <p className="text-sm text-muted-foreground line-clamp-2">{localizeContent(a.excerpt, lang)}</p>
                <div className="mt-4 text-xs text-teal font-semibold">{a.author}</div>
              </div>
            </Card>
          ))}
        </div>
      </section>
      <section>
        <h2 className="font-display text-2xl font-medium mb-6">{t("education.videos")}</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {data.videos.map(v => (
            <Card key={v.id} className="overflow-hidden rounded-2xl border-teal/10" data-testid={`video-${v.id}`}>
              <div className="aspect-video">
                <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${v.youtube_id}`} title={v.title} allowFullScreen/>
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg leading-snug">{localizeContent(v.title, lang)}</h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1"><Play className="w-3 h-3"/> {v.duration}</span>
                  <span>· {v.channel}</span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
